import React from "react"
import classNames from "@utils/classnames"
import styles from "./container.module.scss"

const Container = ({
  children,
  className,
  noPadding = false,
  fakeFullscreen = false,
  sm = false,
}) => {
  return (
    <div
      className={classNames(
        styles.container,
        {
          [styles.containerFakeFullscreen]: fakeFullscreen,
          [styles.containerSm]: sm,
          [styles.containerNoPadding]: noPadding,
        },
        className
      )}
    >
      {children}
    </div>
  )
}

export default Container
